import Vue from 'vue'
import Router from 'vue-router'
// 1. 引入验证 Token 的 API 方法
import { checkToken } from '@/api/user'

Vue.use(Router)
// 目前练题页面不用，新增首页
const App = () => import('@/components/addHome/App')
const MapContainer = () => import('@/components/addHome/MapContainer')
const homeIndex = () => import('@/components/addHome/homeData/index')
// 实用工具
const PhotoEditor = () => import('@/components/addHome/toolMarket/PhotoEditor')

// --- 组件懒加载预定义 ---
const LoginJiaxiao = () => import('@/components/jiaxiao/loginjiaxiao')
const Kaoshi = () => import('@/components/views/kaoshi')
// 后台
const AdminPanel = () => import('@/components/houtai/AdminPanel')
const ImportQuestions = () => import('@/components/houtai/ImportQuestions')
const ExamQuestionList = () => import('@/components/houtai/ExamQuestionList')

// 考试登记展示页面
const ExamManager = () => import('@/components/exam/ExamManager')
const RegistrationForm = () => import('@/components/exam/RegistrationForm')

const homeLayout = () => import('@/components/home/homeLayout')
// 个人测试页面
const jiugongge = () => import('@/components/personalTestingPage/jiugongge')
const imgjiexi = () => import('@/components/personalTestingPage/imgjiexi')

// 2. 定义不需要验证的白名单路径 (登录页)
const whiteList = ['/', 'loginjiaxiao','RegistrationForm','ExamManager', 'MapContainer', 'homeIndex', 'PhotoEditor']

const router = new Router({
  mode: 'history', 
  base: process.env.BASE_URL,
  routes: [
    // --- 业务路由配置 ---
    {
      path: '/',
      name: 'App',
      component: App,
      meta: { title: '众城驾校' }
    },
    {
      path: '/PhotoEditor',
      name: 'PhotoEditor',
      component: PhotoEditor,
      meta: { title: '图片编辑' }
    },{
      path: '/MapContainer',
      name: 'MapContainer',
      component: MapContainer,
      meta: { title: 'MapContainer' }
    },{
      path: '/homeIndex',
      name: 'homeIndex',
      component: homeIndex,
      meta: { title: '众城驾校' }
    },
    {
      path: '/loginjiaxiao',
      name: 'loginjiaxiao',
      component: LoginJiaxiao,
      meta: { title: '驾校登录' }
    },
    // {
    //   path: '/kaoshilogin',
    //   name: 'login',
    //   component: KaoshiLogin,
    //   meta: { title: '考试登录' }
    // },
    
    {
      path: '/homeLayout',
      name: 'homeLayout',
      component: homeLayout,
      meta: { title: '考试登录' }
    },
    {
      path: '/kaoshi',
      name: 'kaoshi',
      component: Kaoshi,
      meta: { title: '考试页面' }
    },
    {
      path: '/AdminPanel',
      name: 'AdminPanel',
      component: AdminPanel,
      meta: { title: '后台管理' }
    },
    {
      path: '/ImportQuestions',
      name: 'ImportQuestions',
      component: ImportQuestions,
      meta: { title: 'json批量导入' }
    },
    {
      path: '/ExamQuestionList',
      name: 'ExamQuestionList',
      component: ExamQuestionList,
      meta: { title: '后台展示数据' }
    },
    {
      path: '/ExamManager',
      name: 'ExamManager',
      component: ExamManager,
      meta: { title: '考试登记' }
    },
    {
      path: '/RegistrationForm',
      name: 'RegistrationForm',
      component: RegistrationForm,
      meta: { title: '考试登记' }
    },
    
    {
      path: '/jiugongge',
      name: 'jiugongge',
      component: jiugongge,
      meta: { title: '九宫格测试' }
    },
    
    {
      path: '/imgjiexi',
      name: 'imgjiexi',
      component: imgjiexi,
      meta: { title: '图片解析' }
    },
    
    // --- 全局捕获未匹配路径 ---
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// --- 3. 【核心】全局前置守卫：刷新页面自动验证 Token 和密码 ---
let isChecking = false; // 防止快速切换路由时重复请求

router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }

  const token = localStorage.getItem('token');

  // A. 如果目标路径在白名单内 (如登录页)，直接放行
  if (whiteList.includes(to.path) || whiteList.includes(to.name)) {
    isChecking = false; // 重置状态
    next();
    return;
  }

  // B. 如果不在白名单，且没有 Token，强制踢回登录页
  if (!token) {
    console.log('[Router Guard] 无 Token，重定向到登录页');
    isChecking = false;
    if (to.path !== '/') {
      next('/');
    } else {
      next();
    }
    return;
  }

  // C. 有 Token，且访问受保护页面 -> 调用后端验证
  if (isChecking) {
    // 如果正在验证中，暂时放行，避免阻塞 UI 导致 "Navigation cancelled"
    // 验证结果会在后续请求拦截器中处理，或者在下一次路由切换时生效
    console.log('[Router Guard] 验证进行中，暂时放行');
    next();
    return;
  }

  isChecking = true;
  console.log('[Router Guard] 正在验证 Token 及密码有效性...');

  try {
    // 调用后端接口
    await checkToken();
    
    console.log('[Router Guard] ✅ 验证通过');
    isChecking = false;
    next(); // 验证成功，允许进入页面

  } catch (error) {
    // ❌ 验证失败 (Token 过期、格式错误、或密码被修改)
    console.warn('[Router Guard] ❌ 验证失败:', error.message);
    
    // 1. 清除本地存储
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    
    isChecking = false;

    // 2. 【关键修复】使用 next('/') 软跳转，而不是 window.location.href
    // 这样 Vue Router 能正确取消当前导航并启动新导航，不会报 "Navigation cancelled"
    if (to.path !== '/') {
      next('/');
    } else {
      next();
    }
  }
});

export default router